/* eslint-disable react/function-component-definition */
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function ApplicationsBarChart({ data }) {
  return (
    <div className="chart-wrapper">
      <h3>Applications Received Per Day</h3>

      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={data}>
          <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip />

          <Bar
            dataKey="value"
            fill="#4CA3FF"
            radius={[6, 6, 0, 0]} // rounded top corners like your screenshot
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
